import React, { type FC } from 'react'

import { selectActiveBanner } from '../../../domain'

import { useAppState, useAppUsecase } from '../State'
import { Banner } from '../common/Notifications'

/**
 * Renders the single active banner (if any) directly in the page layout - unlike `ToastPortal`,
 * there's no portal/stacking engine involved: a banner is full-width (of the content area) and
 * pushes content down, so it has to sit in normal document flow inside the page panel, above
 * the routed page content but never above the side nav, which the frame draws (see `RouteNavigation.tsx`,
 * where this is mounted), not floated via notistack.
 */
export const BannerRenderer: FC = () => {
    const activeBanner = useAppState(selectActiveBanner)
    const bannerUsecase = useAppUsecase('bannerUsecase')

    if (!activeBanner) {
        return null
    }

    return (
        <Banner
            severity={activeBanner.severity}
            title={activeBanner.title}
            description={activeBanner.description}
            action={activeBanner.action}
            onClose={() => bannerUsecase.dismiss()}
        />
    )
}
